export const aiAgent = {
  head: {
    chip: "Réception IA",
    listingLabel: "Logement :",
  },
  globalNote: {
    title: "Paramètres pour tout le compte",
    body: "S'applique à <b>TOUS vos logements</b>. L'agent IA s'occupe de toute personne qui écrit pour la première fois à votre <b>numéro WhatsApp connecté</b> et qui n'est <b>pas encore cliente et n'a aucune réservation</b> : il répond à ses questions et l'oriente vers la réservation.",
  },
  perListingNote: {
    title: "Configuré par logement",
    body: "L'émission de factures utilise l'<b>émetteur de facturation</b> lié à chaque logement ; elle s'active donc et se règle dans les paramètres de chaque logement (et non globalement). Ouvrez un logement et allez dans « Émission de factures ».",
  },
  noEmisor: {
    title: "Ce logement n'a pas d'émetteur de facturation",
    body: "L'émission de factures ne peut pas être activée tant que vous n'avez pas lié un émetteur à ce logement dans <b>Mon compte → Facturation électronique</b>. Chaque émetteur est attribué à un seul logement.",
  },
  master: {
    requiresEmisor: "Nécessite un émetteur de facturation",
    on: "Activé",
    off: "Désactivé",
  },
  cartelQr: {
    title: "Affiche de check-in pour la réception",
    hint: "Imprimez-la et posez-la sur le comptoir : le voyageur la scanne, saisit son numéro de réservation et fait son check-in depuis son téléphone. Utile quand l'OTA n'envoie pas toutes les données.",
    steps: "Le voyageur scanne · saisit son numéro de réservation · complète ses informations.",
    download: "Télécharger l'affiche (PDF)",
    downloading: "Préparation…",
    downloadError: "L'affiche n'a pas pu être préparée.",
    copy: "Copier le lien",
    copied: "Lien copié",
    language: "Langue de l'affiche",
    alsoEnglish: "Ajouter l'anglais en dessous",

    copyManual: "Impossible de copier. Sélectionne le lien et copie-le à la main.",
    popupBlocked: "Le navigateur a bloqué la fenêtre. Copie le lien et ouvre-le dans un autre onglet.",
    loadError: "L'affiche n'a pas pu être chargée.",
    retry: "Réessayer",  },
  checkinSchedule: {
    title: "Quand commence le check-in ?",
    hint: "Planifiez le moment où l'agent envoie le lien de check-in au client. S'applique au niveau du logement.",
  },
  avisoCheckin: {
    title: "Envoyer un e-mail à la fin du check-in",
    hint: "Quand le groupe termine son enregistrement, nous envoyons le récapitulatif de la réservation — titulaire, accompagnants et leurs pièces d'identité — avec la fiche signée en pièce jointe. Pratique pour la loge ou la réception.",
    enable: "Envoyer l'avis",
    steps: "Envoyé une seule fois, quand la dernière personne du groupe s'enregistre.",
    placeholder: "loge@votrehebergement.com",
    add: "Ajouter un e-mail",
    remove: "Retirer",
    max: "{n} e-mails maximum.",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Avis enregistré",
    saveError: "Impossible d'enregistrer.",
    badEmail: "« {email} » n'est pas une adresse valide.",
    needOne: "Ajoute au moins un e-mail pour activer l'avis.",
  },
  field: {
    optional: "(facultatif)",
    yes: "Oui",
    no: "Non",
  },
  variant: {
    nationality: "Nationalité",
    writingStyle: "Style d'écriture",
  },
  robot: {
    title: "Ce que l'agent sait",
  },
  pdf: {
    loaded: "Document importé · l'agent lira son contenu",
    remove: "Supprimer",
    replace: "Remplacer le PDF",
    dropTitle: "Importez un fichier PDF ou Word avec le guide du logement",
    dropHint: "PDF ou .docx · 15 Mo max",
  },
  payments: {
    required: "Nécessite la connexion d'une plateforme de paiement",
    connect: "Connecter une plateforme de paiement →",
  },
  faq: {
    qPlaceholder: "Question · ex. Y a-t-il un parking ?",
    aPlaceholder: "Réponse · ex. Oui, gratuit devant la porte.",
  },
  list: {
    remove: "Supprimer",
    add: "Ajouter",
  },
  footer: {
    saved: "Enregistré",
    save: "Enregistrer les modifications",
  },
  wa: {
    online: "en ligne",
    caption: "Aperçu · se met à jour avec vos paramètres",
    defaultName: "Réception IA",
  },
  errors: {
    pdfType: "Le fichier doit être un PDF ou un Word (.docx).",
    pdfSize: "Le fichier dépasse 15 Mo.",
    pdfNoText: "Nous n'avons pas pu lire de texte dans le document (s'agit-il d'un PDF numérisé ou vide ?). Essayez-en un autre ou utilisez le texte libre.",
    pdfUpload: "Le PDF n'a pas pu être importé.",
    pdfRemove: "Le PDF n'a pas pu être supprimé.",
    loadConfig: "Les paramètres n'ont pas pu être chargés.",
    saveConfig: "Impossible d'enregistrer. Veuillez réessayer.",
  },
  features: {
    general: {
      title: "Paramètres généraux",
      subtitle: "Définissez l'identité et le style de l'agent. Il s'agit d'un paramètre de COMPTE : il s'applique à TOUS vos logements.",
      sections: {
        identity: {
          label: "Identité de l'agent",
          hint: "Comment il se présente et dans quel style il répond.",
        },
      },
      fields: {
        agentName: {
          label: "Nom de l'agent",
          placeholder: "ex. Sofía, Réception Loft Ámbar…",
        },
        persona: {
          label: "Personnalité",
          options: {
            amigable: "Amical et chaleureux",
            profesional: "Professionnel et débrouillard",
            eficiente: "Direct et efficace",
            entusiasta: "Enthousiaste et chaleureux",
            sereno: "Calme et détendu",
          },
        },
        tone: {
          label: "Ton des réponses",
          options: {
            cercano: "Décontracté",
            cordial: "Cordial",
            formal: "Formel",
            profesional: "Professionnel",
          },
        },
        responseLength: {
          label: "Longueur des réponses",
          options: {
            brief: "Brève (1-2 phrases)",
            balanced: "Équilibrée",
            detailed: "Détaillée",
          },
        },
        useEmojis: {
          label: "Utiliser des émojis",
        },
        language: {
          label: "Langue principale",
          options: {
            auto: "Automatique (selon le client)",
            es: "Espagnol",
            en: "Anglais",
            fr: "Français",
            de: "Allemand",
            pt: "Portugais",
            it: "Italien",
          },
        },
        spanishVariant: {
          label: "Style d'écriture (espagnol)",
        },
        signature: {
          label: "Signature de clôture",
          placeholder: "ex. — L'équipe du Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Base de connaissances",
      subtitle: "Tout ce que l'agent IA doit savoir pour servir vos clients avec précision.",
      enableLabel: "L'agent utilise cette base de connaissances",
      sections: {
        knowledge: {
          label: "Connaissances sur le logement",
          hint: "Choisissez comment fournir les informations que l'agent utilisera.",
        },
        behavior: {
          label: "Comportement et limites",
          hint: "Définissez les règles de l'agent et le moment où demander une aide humaine.",
        },
      },
      fields: {
        kbMode: {
          label: "Comment souhaitez-vous fournir les informations ?",
          options: {
            form: "Formulaires",
            text: "Texte libre",
            pdf: "Importer un document",
          },
        },
        propertyType: {
          label: "Type de logement",
          options: {
            apartment: "Appartement",
            house: "Maison",
            villa: "Villa",
            loft: "Loft",
            room: "Chambre",
            cabin: "Cabane",
            hotel: "Hôtel",
            hostel: "Auberge de jeunesse",
          },
        },
        kbText: {
          label: "Informations sur le logement",
          placeholder: "Écrivez ou collez ici TOUT ce que l'agent doit savoir : le WiFi et son mot de passe, le parking, les appareils électroménagers, le chauffage/la climatisation, le règlement intérieur, les recommandations locales…",
          hint: "L'agent utilisera ce texte tel quel pour répondre.",
        },
        kbPdf: {
          label: "Document du logement",
          hint: "Importez le guide du logement au format PDF ou Word (.docx). L'agent lira son contenu pour répondre.",
        },
        description: {
          label: "Informations générales",
          placeholder: "Comment fonctionnent le chauffage et la climatisation, les appareils électroménagers, la régulation de la température, les particularités du logement…",
          hint: "Contexte principal que l'agent utilisera dans chaque réponse.",
        },
        wifiName: {
          label: "Nom du WiFi",
          placeholder: "MyWifi_5G",
        },
        wifiPassword: {
          label: "Mot de passe WiFi",
        },
        parkingInfo: {
          label: "Parking",
          placeholder: "Parking gratuit devant la porte / Parking payant à 100 m / Pas de parking…",
        },
        amenities: {
          label: "Équipements et matériel",
          placeholder: "Cuisine équipée, lave-linge, sèche-linge, climatisation, ascenseur, lit bébé, serviettes…",
        },
        houseRules: {
          label: "Règlement intérieur",
          placeholder: "Non-fumeur, pas de fêtes, animaux non admis, silence de 22h00 à 08h00…",
        },
        localRecommendations: {
          label: "Recommandations locales",
          placeholder: "Restaurants, supermarchés, transports, que visiter à proximité…",
        },
        faqs: {
          label: "Questions fréquentes",
          hint: "Paires de questions-réponses. Vous pouvez joindre des images ou des vidéos à chacune.",
        },
        links: {
          label: "Liens et documents",
          itemPlaceholder: "https://… (guide du logement, manuel, plan)",
          hint: "Ressources externes que l'agent peut consulter.",
        },
        sendAmenityPhotos: {
          label: "Envoyer les photos des équipements et commodités",
          hint: "Si le client demande un équipement qui a des photos, l'agent répond et les lui envoie. S'il n'y en a pas, il répond uniquement par texte.",
        },
        customInstructions: {
          label: "Instructions personnalisées",
          placeholder: "Règles de ton ou de contenu spécifiques. Ex. proposez toujours un départ tardif s'ils posent des questions sur le départ.",
        },
        forbiddenTopics: {
          label: "Sujets ou actions interdits",
          placeholder: "Ex. ne pas accorder de réductions, ne pas confirmer de changements de dates sans validation, ne pas communiquer les données d'autres clients.",
        },
        escalationRules: {
          label: "Quand transférer à un humain",
          placeholder: "Ex. en cas de panne, de réclamation grave ou de demande de remboursement, transférez à l'hôte.",
        },
        fallbackMessage: {
          label: "Message lorsqu'il ne connaît pas la réponse",
          placeholder: "Je n'ai pas ce détail sous la main, mais je préviens l'hôte et nous revenons vers vous tout de suite 🙌",
        },
        humanContact: {
          label: "Contact de l'hôte",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Heures d'assistance humaine",
          placeholder: "Lun–Dim 09h00–21h00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Gérer le check-in automatiquement",
    },
    newBookings: {
      title: "Nouvelles réservations et prospects",
      subtitle: "L'agent s'occupe des nouveaux prospects (les personnes qui écrivent pour la première fois et souhaitent réserver ou ont des questions) et leur envoie le lien de Réservation Directe pour qu'elles finalisent la réservation sur le web. Il s'agit d'un paramètre de COMPTE : il s'applique à tous vos logements.",
      enableLabel: "S'occuper des prospects et des demandes de réservation",
      sections: {
        businessIdentity: {
          label: "Identité de l'entreprise",
          hint: "Le nom sous lequel l'agent se présente à celles et ceux qui n'ont pas encore réservé.",
        },
        newLeads: {
          label: "Nouveaux prospects · premier contact",
          hint: "Comment il s'occupe d'une personne qui écrit pour la première fois, intéressée et qui n'a pas encore réservé.",
        },
        bookingLink: {
          label: "Lien de réservation",
        },
      },
      fields: {
        businessName: {
          label: "Nom de l'entreprise",
          placeholder: "ex. Hostel Elios, Apartamentos del Puerto, Grupo Ámbar…",
          hint: "Lorsqu'une personne sans réservation demande qui vous êtes, l'agent répond « Je suis l'assistant de [ce nom] ». Si vous le laissez vide, il se présente de façon générique, sans préciser de quelle entreprise il s'agit.",
        },
        leadWelcomeMessage: {
          label: "Message de bienvenue pour un nouveau prospect",
          placeholder: "Bonjour ! 👋 Je suis l'assistant du logement. Vous cherchez des dates pour une escapade ou avez-vous des questions ? Je serai ravi de vous aider 😊",
          hint: "Message d'accueil au premier contact, lorsqu'une personne écrit pour la première fois. Il n'est pas répété dans les messages suivants.",
        },
        leadWelcomeVerbatim: {
          label: "Envoyer le message d'accueil tel quel (sans l'adapter)",
          hint: "Activé : l'agent utilise votre message mot pour mot au premier contact. Désactivé : il l'adapte au ton de la conversation.",
        },
        answerKbForLeads: {
          label: "Répondre aux questions même avant la réservation",
          hint: "L'agent répond à leurs questions générales à l'aide de la base de connaissances — même s'ils ne sont pas encore clients — et peut aussi leur envoyer le lien de réservation.",
        },
        proactiveOffer: {
          label: "Suggérer proactivement de réserver",
          hint: "Même si le prospect pose des questions sur d'autres sujets, l'agent l'encourage à réserver et envoie le lien au bon moment, sans insister.",
        },
        offerMessage: {
          label: "Message lors de la proposition de réservation",
          placeholder: "Bien sûr ! Vous pouvez réserver directement ici 👇 Je vous envoie le lien pour choisir vos dates.",
          hint: "Le ton que l'agent adopte lorsqu'il propose la réservation. L'agent ajoute le lien automatiquement.",
        },
      },
    },
    earlyAccess: {
      title: "Gestion de l'heure d'arrivée",
      subtitle: "L'agent gère les demandes d'arrivée anticipée : il enregistre l'heure d'arrivée demandée par le client et la traite selon vos règles.",
      enableLabel: "Gérer les heures d'arrivée",
      sections: {
        request: {
          label: "Traitement des demandes",
          hint: "Comment l'agent répond en fonction de l'heure demandée. Si vous les désactivez, la demande reste en attente pour que vous choisissiez (Approuver / Approuver une autre heure / Prioriser / Refuser).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Répondre « sous réserve de disponibilité » si c'est avant le check-in",
          hint: "L'agent indique au client que vous ferez votre possible ; la demande reste en attente de votre confirmation.",
        },
        autoApproveLate: {
          label: "Approuver automatiquement si c'est après le check-in",
          hint: "Une arrivée aux horaires normaux est confirmée d'elle-même.",
        },
      },
    },
    lateCheckout: {
      title: "Départ tardif",
      subtitle: "L'agent gère les demandes de départ tardif : il valide l'heure, communique le prix et enregistre la demande.",
      enableLabel: "Gérer le départ tardif",
      sections: {
        availability: {
          label: "Disponibilité et horaires",
        },
        extraPrice: {
          label: "Prix de l'heure supplémentaire",
          hint: "Seule la partie après les heures de courtoisie est facturée.",
        },
        messages: {
          label: "Messages",
        },
      },
      fields: {
        standardCheckout: {
          label: "Heure de départ standard",
        },
        courtesyHours: {
          label: "Heures de courtoisie (gratuites)",
          unit: "h",
          hint: "Heures après le départ standard qui ne sont JAMAIS facturées.",
        },
        latestTime: {
          label: "Heure de départ la plus tardive",
          hint: "Limite absolue. Au-delà de la période de courtoisie, les heures supplémentaires sont facturées.",
        },
        subjectToAvailability: {
          label: "Sous réserve de disponibilité",
          hint: "Les heures supplémentaires ne sont proposées que si aucune autre réservation n'arrive ce jour-là.",
        },
        autoConfirm: {
          label: "Confirmer automatiquement si le client accepte",
          hint: "Ne s'applique qu'aux heures gratuites.",
        },
        pricingModel: {
          label: "Modèle de tarification",
          options: {
            fixed: "Prix fixe",
            perHour: "Par heure supplémentaire",
          },
        },
        price: {
          label: "Montant",
          hint: "Prix fixe, ou tarif par heure supplémentaire au-delà de la période de courtoisie.",
        },
        freeIfAvailable: {
          label: "Gratuit s'il n'y a pas d'arrivée le même jour",
          hint: "Si ce jour est libre, les heures supplémentaires ne sont pas facturées non plus.",
        },
        paymentMethods: {
          label: "Moyens de paiement pour les heures supplémentaires",
          options: {
            online: "Paiement en ligne (Stripe) — l'agent envoie un lien",
            cash: "Espèces au départ",
          },
          hint: "Vous pouvez proposer l'un des deux ou les deux. L'agent en informera le client.",
        },
        offerMessage: {
          label: "Message de proposition",
          placeholder: "Besoin de plus de temps ? Nous pouvons proposer un départ jusqu'à 13h00.",
        },
        confirmationMessage: {
          label: "Message de confirmation",
          placeholder: "C'est fait ! Votre départ tardif est confirmé. Profitez bien de ces heures supplémentaires 🙌",
        },
      },
    },
    invoicing: {
      title: "Émission de factures",
      subtitle: "L'agent envoie au client un lien pour compléter ses informations fiscales et télécharger sa facture électronique, à l'aide de l'émetteur de facturation lié à ce logement.",
      enableLabel: "Gérer les demandes de facture",
      sections: {
        whenSend: {
          label: "Quand le lien de facture est-il envoyé ?",
          hint: "Choisissez comment le lien parvient au client. Les options du mode choisi apparaissent ci-dessous.",
        },
        requirements: {
          label: "Conditions pour l'envoyer instantanément",
          hint: "L'agent ne remet le lien qu'aux clients ayant déjà effectué leur check-in et réglé l'intégralité de la réservation ; une fois leurs informations renseignées, la facture est émise et téléchargée instantanément. Pour les réservations OTA (Booking/Airbnb), la facture ne peut être obtenue qu'une fois le service commencé (le séjour a débuté) et le paiement effectué.",
        },
        manualReview: {
          label: "Révision manuelle",
          hint: "Seule la demande du client est enregistrée et reste en attente dans « Factures à envoyer » pour que vous l'émettiez manuellement. Aucune facture n'est générée automatiquement, et peu importe le moment de la demande ou le paiement de la réservation (c'est vous qui la révisez).",
        },
        fiscalData: {
          label: "Informations fiscales de l'émetteur",
          hint: "Les informations fiscales (raison sociale, numéro fiscal, série, VAT, Verifactu) ne se configurent PAS ici : elles proviennent de l'émetteur de facturation lié à ce logement dans Mon compte → Facturation électronique.",
        },
        sendToGuest: {
          label: "Envoi au client",
        },
      },
      modes: {
        after_checkout: {
          label: "Uniquement sur demande",
          desc: "Le concierge IA répond lorsque le client demande sa facture.",
        },
        always_after_checkout: {
          label: "Toujours, à la fin du séjour",
          desc: "À toute personne ayant effectué son check-in, qu'elle le demande ou non. Recommandé.",
        },
      },
      cards: {
        on_request: {
          label: "Dès qu'il le demande",
          desc: "Il reçoit le lien immédiatement, s'il remplit les conditions.",
        },
        after_checkout: {
          label: "À la fin de son séjour",
          desc: "La demande est enregistrée et le lien lui parvient après le départ.",
        },
        manual: {
          label: "Simplement l'enregistrer",
          desc: "Elle reste en attente et vous l'émettez à la main.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Émettre la facture même s'ils ne remplissent pas le formulaire",
          hint: "Elle est émise à partir de leurs informations de check-in et le PDF leur est envoyé par e-mail et WhatsApp. Une facture émise ne peut pas être modifiée.",
        },
        autoIssueAfterHours: {
          label: "Combien de temps attendre avant de l'émettre",
          options: {
            h24: "24 heures après l'envoi du lien",
            h48: "48 heures après l'envoi du lien",
            h72: "72 heures après l'envoi du lien",
          },
        },
        manualSendLink: {
          label: "Envoyer au client le lien pour compléter ses informations fiscales",
          hint: "Si vous l'activez, l'agent envoie le lien pour que le client fournisse ses informations à l'avance. La facture est tout de même émise manuellement.",
        },
        sendToGuest: {
          label: "Envoyer le lien au client par",
          options: {
            email: "E-mail",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Prolonger le séjour",
      subtitle: "L'agent gère les demandes d'ajout de nuits : il vérifie la disponibilité, communique le prix et enregistre la demande.",
      enableLabel: "Autoriser les demandes de prolongation du séjour",
      sections: {
        availability: {
          label: "Disponibilité",
          hint: "Le nombre maximum de nuits est défini automatiquement par la réservation suivante dans le calendrier.",
        },
        price: {
          label: "Prix",
        },
        messages: {
          label: "Messages",
        },
      },
      fields: {
        autoConfirm: {
          label: "Prolonger la réservation automatiquement à la confirmation",
          hint: "Si vous désactivez cette option, cela reste une demande à approuver.",
        },
        useListingRate: {
          label: "Utiliser le tarif par nuit du logement",
          hint: "Calcule le tarif à partir du prix de la réservation.",
        },
        pricePerNight: {
          label: "Prix par nuit supplémentaire",
          hint: "Uniquement si vous n'utilisez pas le tarif du logement.",
        },
        paymentMethods: {
          label: "Moyens de paiement pour les nuits supplémentaires",
          options: {
            online: "Paiement en ligne (Stripe) — l'agent envoie un lien",
            cash: "Espèces",
          },
        },
        offerMessage: {
          label: "Message de proposition",
          placeholder: "Envie de rester plus longtemps ? Je peux ajouter des nuits à votre réservation, sous réserve de disponibilité.",
        },
        confirmationMessage: {
          label: "Message de confirmation",
          placeholder: "Parfait ! J'ai enregistré les nuits supplémentaires. Nous confirmerons dès que le paiement sera effectué 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "sans frais",
      subjectToAvailability: " Sous réserve de disponibilité.",
    },
    default: "Bonjour ! Comment puis-je vous aider ? 😊",
    knowledge: {
      guestWifi: "Quel est le mot de passe du WiFi ? 📶",
      wifiAnswer: "Bien sûr ! Le réseau WiFi est *{name}* et le mot de passe est *{pass}*. Profitez-en bien ! 😊",
      wifiNameFallback: "du logement",
      wifiPassFallback: "••••••",
      genericAnswer: "Bien sûr ! Je vous envoie tout de suite toutes les informations dont vous avez besoin sur le logement 😊",
    },
    checkin: {
      propFallback: "votre logement",
      welcome: "🇫🇷 *Bonjour* 👋 Je suis 🤖 l'assistant virtuel de *{prop}*.\nJe suis là pour vous aider dans votre check-in.\n\nAppuyez sur « Ok » pour continuer le check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Choisissez votre langue · Choose your language",
      langEs: "Français",
      langEn: "English",
      linkMsg: "*Merci* 👋 Voici votre lien pour faire le check-in. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "Bien sûr ! 😊 Vous pouvez réserver directement ici. Je vous envoie le lien pour choisir vos dates :",
      whoAsk: "À qui ai-je l'honneur ?",
      whoAnswer: "Bonjour ! Je suis l'assistant de {biz} 😊 Comment puis-je vous aider ?",
      guestGreeting: "Bonjour ! Avez-vous quelque chose de disponible ce week-end ? 😊",
      howBook: "Super, comment puis-je réserver ?",
      linkLine: "{offer}\n\n🔗 Réservez ici : {link}",
    },
    earlyAccess: {
      guestAsk: "Puis-je arriver plus tôt ? J'arrive vers midi 🙏",
      tentativeReply: "Nous avons noté votre arrivée anticipée à 12h00. Nous ferons de notre mieux pour que tout soit prêt, mais cela dépend du départ du client précédent et du ménage. Nous vous tiendrons informé dès que ce sera disponible 🙏",
      confirmedReply: "Nous avons enregistré votre arrivée anticipée à 12h00. Nous confirmerons sous peu 🙏",
    },
    lateCheckout: {
      courtesyPart: "Vous disposez de {hours}h de délai de courtoisie gratuit après {time}. ",
      costPart: "Un départ jusqu'à {time} coûte {price}{perHour}.",
      perHourSuffix: " par heure supplémentaire",
      payBoth: " Vous pouvez payer en ligne ou en espèces au départ.",
      payCash: " Le paiement se fait en espèces au départ.",
      guestAsk: "Puis-je partir plus tard demain ? 😅",
      guestConfirm: "D'accord, je confirme 👍",
      cashExtra: " (ou en espèces au départ)",
      confirmPayDefault: "C'est fait ! Pour confirmer, effectuez le paiement{extra} :",
      payLabel: "Payer {price}",
      confirmCashDefault: "C'est fait ! Votre départ tardif est confirmé. Le paiement de {price} se fait en espèces au départ. 😊",
    },
    invoicing: {
      guestAsk: "Pouvez-vous m'envoyer la facture ? 🧾",
      linkMsg: "Bonjour ! 👋\n\nVoici votre lien pour générer et télécharger votre facture électronique :\n{link}\n\nVous pouvez revenir à ce lien chaque fois que vous en avez besoin.",
      thanks: "Merci pour votre séjour ! 🙌 Si vous avez besoin de votre facture, voici le lien 👇",
      autoIssueNote: "_({hours}h plus tard, s'ils n'ont pas complété leurs informations)_\n\nNous avons émis votre facture à partir de vos informations de check-in et nous vous l'avons envoyée par e-mail. 📩",
      manualLinkMsg: "Bonjour ! 👋\n\nVoici le lien pour compléter vos informations fiscales :\n{link}\n\nNous examinerons votre demande et émettrons la facture manuellement. 😊",
      manualRegistered: "Bonjour ! 👋 J'ai enregistré votre demande de facture. Nous l'examinerons et l'émettrons manuellement dès que possible. Merci ! 😊",
    },
    extendStay: {
      guestAsk: "Puis-je rester une nuit de plus ? 🌙",
      guestConfirm: "Oui, une nuit de plus 👍",
      rateListing: "au tarif de votre réservation",
      ratePerNight: "pour {price}/nuit",
      nightSingular: "nuit",
      nightPlural: "nuits",
      offerDefault: "Bien sûr ! Je peux ajouter jusqu'à {max} {nights} {rate}.{avail}",
      cashExtra: " (ou en espèces)",
      confirmPayDefault: "Parfait ! Pour confirmer la nuit supplémentaire, effectuez le paiement{extra} :",
      payLabel: "Payer la nuit supplémentaire",
      confirmCashDefault: "Parfait ! J'ai enregistré la nuit supplémentaire. Le paiement se fait en espèces et l'hôte confirmera la prolongation. 😊",
    },
    general: {
      guestAsk: "Bonjour ! À qui ai-je l'honneur ?",
      whoWithName: "Je suis {name}, votre",
      whoNoName: "Je suis votre",
      answer: "Bonjour ! {who} assistant de réception. Comment puis-je vous aider ?{emo}",
    },
  },
  nationalities: {
    auto: "Automatique (selon le client)",
    latam: "Amérique latine (neutre)",
    countries: {
      ES: "Espagne",
      MX: "Mexique",
      CO: "Colombie",
      AR: "Argentine",
      CL: "Chili",
      PE: "Pérou",
      VE: "Venezuela",
      EC: "Équateur",
      UY: "Uruguay",
      PY: "Paraguay",
      BO: "Bolivie",
      CR: "Costa Rica",
      PA: "Panama",
      GT: "Guatemala",
      DO: "Rép. dominicaine",
      PR: "Porto Rico",
      CU: "Cuba",
      FR: "France",
      PT: "Portugal",
      BR: "Brésil",
      US: "États-Unis",
      IT: "Italie",
      BE: "Belgique",
      MA: "Maroc",
      NL: "Pays-Bas",
      CH: "Suisse",
    },
    styles: {
      latamNeutral: "Latino-américain neutre",
      esES: "Standard — informel (tú) · «vale», «genial»",
      esMX: "Standard — «con gusto», «estacionamiento»",
      esCO: "Général — formel (usted) · «con gusto»",
      esCOpaisa: "Paisa (Medellín) — «pues», «hágale»",
      esCOcosta: "Côtier (Caraïbes) — «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá) — formel (usted) · «a la orden»",
      esCOvalle: "Valluno (Cali) — voseo · «vea pues»",
      esCOsantander: "Santander — direct · «de una»",
      esAR: "Voseo — «dale», «buenísimo»",
      esCL: "Chaleureux — «estacionamiento»",
      esPE: "Formel (usted) — andin neutre",
      esVE: "Informel (tú) — «chévere»",
      esEC: "Formel (usted) — andin neutre",
      esUY: "Voseo — «ta», «bo»",
      esPY: "Voseo — chaleureux",
      esBO: "Formel (usted) — andin",
      esCR: "Voseo — «pura vida»",
      esPA: "Informel (tú) — caraïbe",
      esGT: "Formel (usted) — chaleureux",
      esDO: "Informel (tú) — caraïbe",
      esPR: "Informel (tú) — caraïbe",
      esCU: "Informel (tú) — caraïbe",
      frFR: "Français (France)",
      ptPT: "Portugais (Portugal)",
      ptBR: "Portugais (Brésil)",
      enUS: "Anglais américain",
      itIT: "Italien (Italie)",
      frBE: "Français (Belgique)",
      nlBE: "Néerlandais / flamand (Belgique)",
      arMA: "Arabe (Maroc)",
      frMA: "Français (Maroc)",
      nlNL: "Néerlandais",
      deCH: "Allemand suisse",
      frCH: "Français suisse",
      itCH: "Italien suisse",
    },
  },
};
